<template>
  <v-row>
    <v-card class="my-0 ml-3 d-flex flex-column">
      <v-navigation-drawer
        v-model="drawer"
        width="350"
        :mini-variant.sync="mini"
        permanent
        style="height: 95vh"
      >
        <v-list-item class="px-3 mt-2">
          <v-list-item-avatar>
            <v-img src="../assets/images/gmu-logo.png"></v-img>
          </v-list-item-avatar>

          <v-list-item-title> ACCESS </v-list-item-title>

          <v-btn icon @click.stop="mini = !mini">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>

        <v-list-item v-if="!mini" class="px-3">
          Advancing Community-Centered, Efficient, and Sustainable Solutions
          (ACCESS) for Walking, Biking, and Micromobility Infrastructure
        </v-list-item>

        <v-divider style="margin-top: 10px"></v-divider>

        <v-list class="pt-0">
          <v-list-group
            prepend-icon="mdi-database"
            no-action
            :value="true"
            active-class="font-weight-bold blue lighten-5"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Data Source</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list>
              <v-list-item
                v-for="source in data_sources"
                :key="source.id"
                >
                <v-checkbox
                  v-model="selected_sources"
                  :label="source.label"
                  :value="source.id"
                  @change="handleCheckboxChange(source.id)"
                ></v-checkbox>
              </v-list-item>
            </v-list>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <!-- footer -->
      <v-card-actions
        v-if="!mini"
        class="p-0 my-0"
        style="height: 10vh; position: absolute; bottom: 0; width: 100%"
      >
        <div
          class="font-weight-bold"
          style="font-family: 'Open Sans', sans-serif"
        >
          <div
            class="primary--text ml-4 font-weight-bold"
            style="font-size: 10pt"
          >
            George Mason Research Team
          </div>
          <div
            class="primary--text ml-4 font-weight-bold"
            style="font-size: 10pt"
          >
            funded by National Science Foundation <br />
            CIVIC Program
          </div>
        </div>
        <!-- <v-spacer></v-spacer> -->
      </v-card-actions>
    </v-card>

    <v-col class="px-0 py-0">
      <Mapview
        :update_filter="update_filter"
        :selected_sources="selected_sources"
        style="height: 100%; width: 100%"
      />
    </v-col>
  </v-row>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap");
</style>

<script>
import Mapview from "@/components/Mapview";
// import axios from 'axios';

export default {
  components: {
    Mapview,
  },
  data() {
    return {
      loading: false,
      drawer: true,
      mini: false,
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      domain: this.$domain,
      data_sources: [
        { id: "novafss", label: "NoVA FSS" , checked: true},
        { id: "vdotcrashes", label: "VDOT Crashes", checked: false},
        { id: "infrahubcomplaint", label: "InfraHub Complaints", checked: false },
      ],
      selected_sources: [],
      update_filter: null,
    };
  },
  mounted() {
    if (this.data_sources.length > 0) {
      this.selected_sources = [this.data_sources[0].id]; 
    }
  },
  methods: {
    handleCheckboxChange(selectedId) {
      this.selected_sources = [selectedId];
      this.update_filter = !this.update_filter;
    },
  },
};
</script>
